// Plantillas básicas para iniciar estados controlados
export const emptyIssuer = {
  rut: '',
  business_name: '',
  phone_number: '',
  email: '',
  business_activity: '',
  activity_code: '',
  sii_branch_code: '',
  address: '',
  district: '',
  city: ''
}

export const emptyReceiver = {
  rut: '',
  business_name: '',
  contact: '',
  business_activity: '',
  address: '',
  district: '',
  city: ''
}

export const emptyDetail = {
  item_name: '',
  quantity: 1,
  unit_price: 0,
  line_number: 1,
  item_description: '',
  discount_percent: '',
  item_code: '',
  unit: 'UN',
  other_tax: '',
  item_type_code: ''
}

export const emptyHeader = {
  purchase_transaction_type: '',
  sale_transaction_type: '',
  payment_method: '2',
  due_date: ''
}

export const emptyReference = {
  reference_type: '',
  reference_folio: '',
  reference_date: '',
  reference_reason: '',
  dte_type_code: ''
}

export const fieldLabels = {
  rut: 'Rut',
  business_name: 'Razón social',
  phone_number: 'Teléfono',
  email: 'Correo electrónico',
  business_activity: 'Actividad económica',
  activity_code: 'Código de actividad',
  sii_branch_code: 'Código SII sucursal',
  address: 'Dirección',
  district: 'Comuna',
  city: 'Ciudad',
  contact: 'Contacto'
}

export const fieldLabelsHeader = {
  purchase_transaction_type: 'Tipo de compra',
  sale_transaction_type: 'Tipo de venta',
  payment_method: 'Método de pago',
  due_date: 'Fecha de vencimiento'
}
